module.exports = __webpack_public_path__ + "img/ic-chev-e.e265ad85.svg";